import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// material mui
import {
    Typography,
    Grid,
    Avatar,
    Link,
    Chip,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import DEFAULT_USER_IMAGE from './../../assets/images/users/default_user.png';
import {
    TRANSACTION_STATUS,
    TRANSACTION_TRANSFER_STATUS,
    USER_TYPE
} from 'store/constant';

// third party
import moment from 'moment';

export const TransactionList = ({ rows, page, limit, viewType }) => {

    const theme = useTheme();
    const { venueUuid } = useParams();
    const navigate = useNavigate();

    const getUserType = function (userType) {
        let findObj = USER_TYPE.find(st => st.value === userType);
        return findObj ? findObj.name : '';
    };

    const handleViewVenue = (venue_uuid) => {
        navigate(`/venue/view/${venue_uuid}`)
    };

    const openTransactionDetails = (bookingUuid) => {
        if (venueUuid) {
            navigate(`/venue/view/${venueUuid}/${bookingUuid}`);
        } else {
            navigate(`/transaction/view/${bookingUuid}`);
        }
    };

    const getTransactionStatus = (status) => {
        let findObj = TRANSACTION_STATUS.find(x => x.value === status);
        return findObj ? findObj.name : '';
    };

    const getTransactionTransferStatus = (status) => {
        let findObj = TRANSACTION_TRANSFER_STATUS.find(x => x.value === status);
        return findObj ? findObj.name : '';
    };

    const getAmount = (amount) => {
        return parseFloat(amount).toFixed(2);
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} >Transaction Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Customer</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }} align='center'>Booked Type</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Venue</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>Booking Id</TableCell>
                        <TableCell align='center'>Payment Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align='center'>Transfer Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Paid Amount</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Refund Amount</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Status</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Created By</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Link Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Order Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Payment Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Transfer Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Reversal Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Refund Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Transfer Account Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Razorpay Settlement Id</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                <Link underline='always' sx={{ cursor: 'pointer' }} onClick={() => openTransactionDetails(row.uuid)}>
                                                    {row.transaction_id}
                                                </Link>
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="User" src={row.booked_user_image ? row.booked_user_image : DEFAULT_USER_IMAGE} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.booked_user_firstname} {row.booked_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.booked_user_code} / {getUserType(row.booked_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '70px' }}>
                                    {
                                        row.booking_type === 'venue' && row.uuid_board_booking ? 'Court, Board' : row.uuid_board_booking ? 'Board' : 'Court'
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {
                                                    viewType ? (row.venue_details ? row.venue_details.venue_name : '') : (
                                                        <Link underline='always' onClick={() => handleViewVenue(row.venue_details.uuid_venue)} sx={{
                                                            cursor: 'pointer'
                                                        }}>{row.venue_details ? row.venue_details.venue_name : ''}</Link>
                                                    )
                                                }
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {
                                                    row.turf_details ? row.turf_details.turf_name : ''
                                                }
                                                {
                                                    row.board_details ? ' / ' + row.board_details.name : ''
                                                }
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', paddingLeft: '80px' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        {
                                            row.slot_booking_slot_id && row.brd_booking_code ? `${row.slot_booking_slot_id} / ${row.brd_booking_code}` :
                                                row.slot_booking_slot_id ? row.slot_booking_slot_id : row.brd_booking_code
                                        }
                                    </Typography>
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.status === 'paid' ? (
                                            <Chip
                                                label={getTransactionStatus(row.status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : row.status === 'refund_processed' ? (
                                            <Chip
                                                label={getTransactionStatus(row.status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.secondary.main
                                                            : theme.palette.secondary.light + 60,
                                                    color: theme.palette.secondary.dark
                                                }}
                                            />
                                        ) : (row.status === 'failed' || row.status === 'cancelled' || row.status === 'refund_failed') ? (
                                            <Chip
                                                label={getTransactionStatus(row.status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label={getTransactionStatus(row.status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell align='center'>
                                    {row.booking_type === 'board' ? '-' : (
                                        row.transfer_status === 'completed' || row.transfer_status === 'reversed' ? (
                                            <Chip
                                                label={getTransactionTransferStatus(row.transfer_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : row.transfer_status === 'cancelled' ? (
                                            <Chip
                                                label={getTransactionTransferStatus(row.transfer_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label={getTransactionTransferStatus(row.transfer_status)}
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.warning.light + 60,
                                                    color: theme.palette.warning.dark
                                                }}
                                            />
                                        ))
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }} align='right'>
                                    {getAmount(row.amount)}
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }} align='right'>
                                    {getAmount(row.refund_amount)}
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        row.deleted === 0 ? (

                                            <Chip
                                                label="Active"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.success.light + 60,
                                                    color: theme.palette.success.dark
                                                }}
                                            />
                                        ) : (
                                            <Chip
                                                label="Inactive"
                                                size="medium"
                                                sx={{
                                                    background:
                                                        theme.palette.mode === 'dark'
                                                            ? theme.palette.dark.main
                                                            : theme.palette.error.light + 60,
                                                    color: theme.palette.error.dark
                                                }}
                                            />
                                        )
                                    }
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.created_user_firstname} {row.created_user_lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.created_user_code} / {getUserType(row.created_user_type)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell align='center'>{row.razorpay_link_id ? row.razorpay_link_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_order_id ? row.razorpay_order_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_payment_id ? row.razorpay_payment_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_transfer_id ? row.razorpay_transfer_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_reversal_id ? row.razorpay_reversal_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_refund_id ? row.razorpay_refund_id : '-'}</TableCell>
                                <TableCell align='center'>{row.transfer_account_id ? row.transfer_account_id : '-'}</TableCell>
                                <TableCell align='center'>{row.razorpay_settlement_id ? row.razorpay_settlement_id : '-'}</TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>

        </TableContainer >
    );
}